module.exports = __webpack_public_path__ + "img/icon_sick.7cae2d11.svg";